module.exports = {"TXTCLI_City":{"id":"TXTCLI_City","defaultMessage":"Stadt","flags":["TRACK"],"track":"City"}}